import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import useUser from 'shared/hooks/use-user'
import useSWR from 'swr'
import { PUBLIC_API_SETTINGS } from '../api/public-api-settings-api'
import { PublicApiSettingsViewInterface } from '../types/public-api-settings-interface'

export function usePublicApiKeys() {
  const { user } = useUser()
  const { fetcher } = useFetch<RequestMethodsEnum.get, PublicApiSettingsViewInterface[]>({
    method: RequestMethodsEnum.get,
  })

  const { data: publicApiKeys, mutate } = useSWR(() => user && `${PUBLIC_API_SETTINGS}`, fetcher)

  return { publicApiKeys, mutate }
}
